import styled from 'styled-components';

import { grey10 } from 'constants/variables';

const MediaCaption = ({ children }) => (
  <CaptionWrapper className="fs-12 mt-16 mb-16 pb-16 tc-secondary">
    {children}
  </CaptionWrapper>
);

const CaptionWrapper = styled.p`
  border-bottom: 2px solid ${grey10};
`;

export default MediaCaption;
